export async function copyToClipboard(text: string) {
  await global.navigator.clipboard.writeText(text);
  alert("URLをクリップボードにコピーしました");
}
